import React from "react";

function News() {
  return <h2>hacker news starter</h2>;
}

export default News;
